import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { FORGOT_PASSWORD } from "../../utils/url-builder";
import { post } from "../../utils/api";
import Logo from "../../assets/img/logo.svg";
import "../../assets/css/common.scss";
import Snackbar from "@material-ui/core/Snackbar";
import BaseService from "../../store/services/base.service";
import { EmailValidationError } from "../../utils/common-utils";
import { withTranslation } from "react-i18next";
import { WEBSITE_URL } from "../../config";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorText: "",
      page1: true,
      page2: false,
      email: "",
      code: "",
      password: "",
      confirmpassword: "",
      id: "", // users unique id
      errmsg: " ",
      openerrmsg: false
    };
  }

  onEmailEnter(event) {
    this.setState({ email: event.target.value });
    this.setState({ errorstatus: false });
    this.setState({ errorText: "" });
  }

  onCodeEnter(event) {
    this.setState({ code: event.target.value });
    this.setState({ errorstatus: false });
    this.setState({ errorText: "" });
  }

  onPasswordEnter(event) {
    this.setState({ password: event.target.value });
    this.setState({ passworderrorstatus: false });
    this.setState({ passworderrorText: "" });
  }

  onConfirmPasswordEnter(event) {
    this.setState({ confirmpassword: event.target.value });
    this.setState({ errorstatus: false });
    this.setState({ errorText: "" });
  }

  passwordResetClick = async () => {
    if (this.state.email === "") {
      this.setState({
        errorstatus: true,
        errorText: "Please enter Email Address"
      });
    } else if (EmailValidationError(this.state.email)) {
      this.setState({
        errorstatus: true,
        errorText: "Invalid Email Address"
      });
    } else {
      const url = FORGOT_PASSWORD.sendRecoveryCode();
      await new BaseService().makePostRequestGeneric(url, {
        email: this.state.email.toLowerCase(),
        role: "learner"
      });
      this.setState({ page1: false, page2: true });
    }
  };

  resetPasswordClick = async () => {
    if (this.state.password === "") {
      this.setState({ passworderrorstatus: true });
      this.setState({ passworderrorText: "Enter Password" });
    } else if (this.state.confirmpassword === "") {
      this.setState({ errorstatus: true });
      this.setState({ errorText: "Re-Enter Password" });
    } else if (this.state.confirmpassword !== this.state.password) {
      this.setState({ errorstatus: true });
      this.setState({ errorText: "Password MisMatch" });
    } else {
      const url = FORGOT_PASSWORD.resetPassword();
      await new BaseService().makePostRequestGeneric(url, {
        id: this.state.id,
        password: this.state.password
      });
      this.setState({ page3: false, page4: true });
    }
  };

  loginClick = () => {
    // this.props.history.push("/");
    window.location.replace(WEBSITE_URL);
  };

  signUpClick = () => {
    // this.props.history.push("/signup");
    window.location.replace(WEBSITE_URL);
  };

  render() {
    const { t } = this.props;
    if (this.state.page1) {
      return (
        <div>
          {
            <div className="card signin-card">
              <div className="text-left mb-2">
                <img src={Logo} alt="Logo" />
              </div>
              <div>
                <p className="header-title">
                  {t("Did you forget your password")}?
                </p>
              </div>
              <div>
                <p className="text-black">
                  {t(
                    "Please enter your registered kneura email-id and we will send you a reset link"
                  )}
                  .
                </p>
              </div>
              <TextField
                id="email-id"
                label="Email Address"
                className="input-field"
                margin="normal"
                style={emailbox}
                value={this.state.email}
                helperText={this.state.errorText}
                error={this.state.errorstatus}
                onChange={this.onEmailEnter.bind(this)}
              />
              <div className="margin-center">
                <button
                  className="btn-button-learn col-full"
                  onClick={this.passwordResetClick}
                >
                  {t("Next")}
                </button>
              </div>
              <p className="text-secondary text-center">
                <span className="text-black">
                  {t("Back to")}
                  <button className="link ButtonLink" onClick={this.loginClick}>
                    {" Sign In >"}
                  </button>
                </span>
              </p>
            </div>
          }
          <Snackbar
            message={t(this.state.errmsg)}
            open={this.state.openerrmsg}
            onClose={() => this.setState({ openerrmsg: false })}
            autoHideDuration={2000}
          />
        </div>
      );
    } else if (this.state.page2) {
      return (
        <div>
          {
            <div className="card signin-card">
              <div className="text-left mb-2">
                <img src={Logo} alt="Logo" />
              </div>
              <div>
                <p className="text-center header-title">
                  {t("Please check your email for password recovery mail")}
                </p>
              </div>
              <div>
                <p className="text-center text-secondary">
                  {t("Recovery code is sent to ")}
                  {this.state.email}.{" "}
                  {t(
                    "In case you didn’t get a mail, please check the spam folder"
                  )}
                  .
                </p>
              </div>
              <button
                className="btn-secondary-button col-full"
                onClick={this.loginClick}
              >
                <span className="text-black">{" Go to Sign In >"}</span>
              </button>
              <p className="text-left">
                <span
                  className="link text-primary"
                  onClick={this.passwordResetClick}
                >
                  {" "}
                  {t("Resend recovery email to")} {this.state.email}
                </span>
              </p>
            </div>
          }
          <Snackbar
            message={t(this.state.errmsg)}
            open={this.state.openerrmsg}
            onClose={() => this.setState({ openerrmsg: false })}
            autoHideDuration={2000}
          />
        </div>
      );
    }
  }
}

const emailbox = {
  marginTop: "-5px"
};

export default withTranslation()(ForgotPassword);
